import { useEffect, useState } from 'react'

/**
 * Dimensions de la fenêtre, suivies en direct.
 *
 * Sert à dimensionner les graphiques : une hauteur fixe de 300 px convient à
 * un téléphone et gaspille la moitié d'un écran d'ordinateur. Les points de
 * rupture CSS ne suffisent pas ici — `lightweight-charts` a besoin d'une
 * hauteur en pixels, pas d'une classe.
 *
 * On écoute aussi `visualViewport` : sur iOS, l'ouverture du clavier réduit la
 * zone visible sans déclencher `resize` sur `window`.
 */
export function useViewport() {
  const [size, setSize] = useState(() => ({
    width: typeof window === 'undefined' ? 1024 : window.innerWidth,
    height: typeof window === 'undefined' ? 768 : window.innerHeight,
  }))

  useEffect(() => {
    const update = () => setSize({ width: window.innerWidth, height: window.innerHeight })
    window.addEventListener('resize', update)
    window.addEventListener('orientationchange', update)
    window.visualViewport?.addEventListener('resize', update)
    return () => {
      window.removeEventListener('resize', update)
      window.removeEventListener('orientationchange', update)
      window.visualViewport?.removeEventListener('resize', update)
    }
  }, [])

  return {
    ...size,
    /** Seuil à partir duquel l'écran accueille deux colonnes. */
    isWide: size.width >= 1280,
  }
}
